import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { GreenText } from 'components'
import {
  Needs7501DocumentMichiganEmailExporterDto,
  needs7501DocumentMichiganEmailExporterValidationSchema
} from 'dtos/needs7501DocumentMichiganEmailExporterDto'
import { Formik } from 'formik'

interface Needs7501DocumentMichiganEmailExporterDialogProps {
  initialValues: Needs7501DocumentMichiganEmailExporterDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: Needs7501DocumentMichiganEmailExporterDto) => void
  open: boolean
}

export default function Needs7501DocumentMichiganEmailExporterDialog({
  initialValues,
  isLoading,
  onClose,
  onSave,
  open
}: Needs7501DocumentMichiganEmailExporterDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          values.sentToEmailExporterDateTime = new Date().toISOString()
          onSave(values)
          formikHelpers.setSubmitting(false)
        }}
        validateOnBlur
        validateOnChange
        validationSchema={needs7501DocumentMichiganEmailExporterValidationSchema}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Needs 7501 Document - Email Exporter</DialogTitle>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isSubmitting || isLoading}
                      error={Boolean(touched.specialNotes && errors.specialNotes)}
                      fullWidth
                      helperText={touched.specialNotes && errors.specialNotes}
                      label='Special Notes'
                      maxRows={4}
                      minRows={4}
                      multiline
                      name='specialNotes'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      size='small'
                      value={values.specialNotes || ''}
                      variant='outlined'
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <GreenText variant='outlined'>
                      {`**Special Notes:**

A free-type field where users can add content that will be included in the body
of the "Missing 7501 Document Notification Email."

---

**Cancel Button:**

Clicking this button will close the dialog without saving changes.

---

**Send Button:**

Clicking this button will save the contents of the Special Notes field and open
the user's Outlook email client to send the notification email.

---
`}
                    </GreenText>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button disabled={isLoading || isSubmitting} variant='text' color='inherit' onClick={onClose}>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading || isSubmitting} type='submit' variant='contained'>
                  SEND
                </LoadingButton>
              </DialogActions>
            </form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
